import React from "react";
import { BackgroundImage, HighEquipments, HomeExperience, ServiceHeader, WhatCustomerSays } from "../../ThirdComponents";
import { doctorData } from "../../thirdUtils/constant";
import { FaFacebookF, FaTwitter, FaPinterestP } from "react-icons/fa6";

const ThirdTeam = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    return (
        <div>
            <BackgroundImage {...props} heading={selectedLanguage?.txt_our_team_heading} mainClass='third-design-team-banner' />
            <ServiceHeader title={selectedLanguage?.txt_our_doctors} heading={selectedLanguage?.txt_team_of_professionals} text={selectedLanguage?.txt_it_is_important_to_take_care} />
            <div className="third-design-doctor-container">
                {
                    doctorData?.map((v, i) => {
                        return (
                            <div data-aos="fade-up"
                                data-aos-easing="ease-out-cubic"
                                data-aos-delay="100"
                                data-aos-offset="0"
                                data-aos-duration="1500">
                                <div className="third-desin-doctor-overlap-div">
                                    <h2>
                                        {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                    </h2>
                                    <p>
                                        {isELSelect ? v?.role : (isAlSelect ? v?.alRole : v?.glRole)}
                                    </p>
                                    <div>
                                        <div>
                                            <button><FaFacebookF /></button>
                                        </div>
                                        <div>
                                            <button><FaTwitter /></button>
                                        </div>
                                        <div>
                                            <button><FaPinterestP /></button>
                                        </div>
                                    </div>
                                </div>
                                <img src={v?.img} alt="" />
                            </div>
                        )
                    })
                }
            </div>
            <WhatCustomerSays {...props} />
            <HighEquipments {...props} secondClass='high-equipments-team-screen-main' />
            <HomeExperience {...props} />
        </div>
    )
}


export default ThirdTeam